import { buildPayoutOptionColumnDefs } from "helpers/Pricer/payoutOptionGrid";
import { buildQuickAddInputColumns } from "./quickAddInputColumns";

/**
 * Pricer columns through Ask Qty with the Pricer's own editable rules and cell
 * renderers (tenor and option type dropdowns, Live, lock), then the inputs.
 * The renderers read a Quick Add scoped PricerContext, so every edit goes
 * through the Pricer endpoints against the staged option.
 */
export function buildQuickAddStagingColumnDefs({
  darkTheme,
  notTrader,
  editable,
  rowEditingData,
}) {
  const pricerColumns = buildPayoutOptionColumnDefs({
    darkTheme,
    editable,
    rowEditingData,
    notTrader,
    secondaryCompaniesEstColumns: [],
    estColumns: { configurable: false, available: [], selection: [] },
  }).map((col) =>
    col.headerCheckboxSelection || col.checkboxSelection
      ? {
          ...col,
          hide: true,
          checkboxSelection: false,
          headerCheckboxSelection: false,
        }
      : col
  );

  return [...pricerColumns, ...buildQuickAddInputColumns()];
}
